module.exports = __webpack_public_path__ + "static/media/cornet.4b2d11bf.jpg";